

export class Guard {

    static required(argInfo) {
        if (!argInfo) {
            throw new Error(`argument exception: 'argInfo' is missing or undefined`);
        }

        const argName = Object.keys(argInfo)[0];
        if (!argInfo[argName]) {
            throw new Error(`argument exception: '${argName}' is missing or undefined`);
        }
    }
}



// WEBPACK FOOTER //
// ./app/shared/guard.ts